import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { Range } from 'types';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetHoldingClassAvailableRangeProps = {
  holdingClassId: string;
  sharesCount: number;
  addedRanges: Range[];
  useFirstAvailableRange: boolean;
};

export const getHoldingClassAvailableRange =
  ({
    holdingClassId,
    sharesCount,
    addedRanges,
    useFirstAvailableRange = false,
  }: GetHoldingClassAvailableRangeProps) =>
  async (dispatch: Dispatch) => {
    const body = {
      holdingClassId,
      sharesCount,
      addedRanges,
      useFirstAvailableRange,
    };

    try {
      const { data } = await axiosV1.post(
        '/holdingClasses/available-range',
        body
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
